function CloseRightSideBar (to, from, next) {
  this.$emit('right-close')
  next()
}

function AdjustWindowHeightForSideMenu (to, from) {
  this.$emit('evaluate-window-height')
}

export {
  CloseRightSideBar,
  AdjustWindowHeightForSideMenu
}



// WEBPACK FOOTER //
// ./src/middleware.js